import EventService from '@/services/EventService';

export default {
    data() {
        return { volumetricWeightReady: false, volumetricWeightContext: null };
    },
    computed: {
        volumetricWeightField() {
            return Object.values(this.module.fields || {}).find(field => field.name === 'cf_2484');
        }
    },
    mounted() {
        const ready = () => this.$nextTick(() => { this.volumetricWeightReady = true; });
        if (this.id) {
            EventService.fetchRecord('WayBill', this.id).then(response => {
                this.volumetricWeightContext = response.data.result.volumetricWeight;
            }).finally(ready);
        } else {
            ready();
        }
    },
    watch: {
        'formValues.wlength': 'updateVolumetricWeight',
        'formValues.wwidth': 'updateVolumetricWeight',
        'formValues.wheight': 'updateVolumetricWeight',
        'formValues.wagent': 'updateVolumetricWeight'
    },
    methods: {
        updateVolumetricWeight() {
            if (!this.volumetricWeightReady || !this.volumetricWeightField) return;
            const context = this.volumetricWeightContext || {};
            if (context.manual) return;
            const divisors = context.divisors || this.module.volumetricWeightDivisors || {};
            let operator = this.formValues.wagent || context.operator || '';
            const aliases = {'КСЭ': 'CSE', 'Pony Express': 'PonyExpress', 'Zest Express': 'ZestExpress', 'Экспресс-Почта': 'ExpressPost'};
            operator = aliases[operator] || operator;
            const key = Object.keys(divisors).find(name => name.toLowerCase() === operator.toLowerCase());
            const divisor = Number(divisors[key]) > 0 ? Number(divisors[key]) : 5000;
            const sizes = ['wlength', 'wwidth', 'wheight'].map(name =>
                Number(String(this.formValues[name] || '').replace(/[\s\u00a0]/g, '').replace(',', '.')));
            const weight = sizes.every(size => Number.isFinite(size) && size > 0)
                ? Math.round(sizes.reduce((volume, size) => volume * size, 1) / divisor * 100) / 100 : '';
            this.$set(this.formValues, 'cf_2484', weight);
        }
    }
};
